const getBrowserVisibilityProp = () => {
  if (typeof document.hidden !== 'undefined') {
    return 'visibilitychange'
  } else if (typeof document.msHidden !== 'undefined') {
    return 'msvisibilitychange'
  } else if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitvisibilitychange'
  }
}

const getBrowserDocumentHiddenProp = () => {
  if (typeof document.hidden !== 'undefined') {
    return 'hidden'
  } else if (typeof document.msHidden !== 'undefined') {
    return 'msHidden'
  } else if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitHidden'
  }
}

const isDomHidden = () => {
  return document[getBrowserDocumentHiddenProp()]
}

export const diffNowSec = (timeSec) => {
  return Math.abs(timeSec - Math.ceil(Date.now() / 1000))
}

export const diffNowMs = (timeMs) => {
  return Math.abs(timeMs - Date.now())
}

export const vbchange = {
  getBrowserVisibilityProp,
  isDomHidden,
  diffNowSec,
  diffNowMs,
}
export default vbchange
